import { SerialDescriptorForNullable2slcv65za9oog as SerialDescriptorForNullable } from '../internal/NullableSerializer.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerialDescriptor2pelqekb5ic3a as SerialDescriptor } from './SerialDescriptor.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function getContextualDescriptor(_this__u8e3s4, descriptor) {
  var tmp0_safe_receiver = get_capturedKClass(descriptor);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = _this__u8e3s4.i1p(tmp0_safe_receiver);
    tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.x1m();
  }
  return tmp;
}
function get_capturedKClass(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ContextDescriptor()) {
    tmp = _this__u8e3s4.r1p_1;
  } else {
    if (_this__u8e3s4 instanceof SerialDescriptorForNullable()) {
      tmp = get_capturedKClass(_this__u8e3s4.n1p_1);
    } else {
      tmp = null;
    }
  }
  return tmp;
}
var ContextDescriptorClass;
function ContextDescriptor() {
  if (ContextDescriptorClass === VOID) {
    class $ {
      constructor(original, kClass) {
        this.q1p_1 = original;
        this.r1p_1 = kClass;
        this.s1p_1 = this.q1p_1.a1o() + '<' + this.r1p_1.o1() + '>';
      }
      a1o() {
        return this.s1p_1;
      }
      equals(other) {
        var tmp0_elvis_lhs = other instanceof ContextDescriptor() ? other : null;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var another = tmp;
        return equals(this.q1p_1, another.q1p_1) && another.r1p_1.equals(this.r1p_1);
      }
      hashCode() {
        var result = this.r1p_1.hashCode();
        result = imul(31, result) + getStringHashCode(this.s1p_1) | 0;
        return result;
      }
      toString() {
        return 'ContextDescriptor(kClass: ' + toString(this.r1p_1) + ', original: ' + toString(this.q1p_1) + ')';
      }
      t1p() {
        return this.q1p_1.t1p();
      }
      m1p() {
        return this.q1p_1.m1p();
      }
      u1p() {
        return this.q1p_1.u1p();
      }
      v1p() {
        return this.q1p_1.v1p();
      }
      w1p() {
        return this.q1p_1.w1p();
      }
      x1p(index) {
        return this.q1p_1.x1p(index);
      }
      y1p(name) {
        return this.q1p_1.y1p(name);
      }
      z1p(index) {
        return this.q1p_1.z1p(index);
      }
      a1q(index) {
        return this.q1p_1.a1q(index);
      }
      b1q(index) {
        return this.q1p_1.b1q(index);
      }
    }
    initMetadataForClass($, 'ContextDescriptor', VOID, VOID, [SerialDescriptor()]);
    ContextDescriptorClass = $;
  }
  return ContextDescriptorClass;
}
function withContext(_this__u8e3s4, context) {
  return new (ContextDescriptor())(_this__u8e3s4, context);
}
//region block: exports
export {
  getContextualDescriptor as getContextualDescriptor2n1gf3b895yb8,
  withContext as withContext3ge61vpog00ae,
};
//endregion

//# sourceMappingURL=ContextAware.mjs.map
